<template>
  <section>
    <project-header :bgColor="projectData.projectColor">
      <h2 slot="projectTitle" ref="projectTitle">{{projectData.subject}}</h2>
      <i slot="year">{{projectData.year}}</i>
      <i slot="team">{{projectData.team}}</i>
      <i slot="participation">{{projectData.participation}}</i>
    </project-header>
    <project-body>
      <slot></slot>
    </project-body>
    <project-footer :nextSlug="nextProjectData.slug" :nextBgColor="nextProjectData.projectColor">
      <i slot="projectTitle">{{projectData.subject}}</i>
      <i slot="year">{{projectData.year}}</i>
      <i slot="team">{{projectData.team}}</i>
      <i slot="participation">{{projectData.participation}}</i>
      <h2 slot="nextProject">{{nextProjectData.subject}}</h2>
    </project-footer>
  </section>
</template>

<script>
  import axios from 'axios'

  import ProjectHeader from '@/components/ProjectHeader.vue'
  import ProjectBody from '@/components/ProjectBody.vue'
  import ProjectFooter from '@/components/ProjectFooter.vue'

  export default {
    name: 'project-layout',
    props: ['projectName'],
    components: {
      'project-header': ProjectHeader,
      'project-body': ProjectBody,
      'project-footer': ProjectFooter
    },
    data () {
      return {
        projectData: '',
        nextProjectData: ''
      }
    },
    created () {
      let thisProjectNumber = 0
      let nextProjectNumber = 0

      axios.get('/static/data/works.json')
      .then((response) => {
        response.data.projects.forEach((work) => {
          if (work.slug === this.projectName) {
            this.projectData = work
            nextProjectNumber = thisProjectNumber + 1
          }
          thisProjectNumber++
        })

        if (response.data.projects[nextProjectNumber]) {
          this.nextProjectData = response.data.projects[nextProjectNumber]
        } else {
          this.nextProjectData = response.data.projects[0]
        }
      })
      .catch((error) => {
        console.log(error)
      })
    }
  }
</script>

<style lang="scss" scoped>
  section {
    width: 100%;
    margin: 0 auto;
  }

  .footer-next {
    & h2 {
      color: #fff;
      font-weight: 500;
    }
  }
</style>


// WEBPACK FOOTER //
// src/layouts/ProjectLayout.vue